import Home from './pages/home';
import ErrorPage from './pages/error'
import NewTraductor from './pages/traductor';
import Dashboard from './pages/dashboard';
import GlossaryManagement from './pages/GlossaryManagement';
import './App.scss';

import {
  BrowserRouter ,
  Routes,
  Route
} from "react-router-dom";


function App() {
  return (
    <BrowserRouter>
    <Routes>
        <Route index element={<Home />} />
        <Route path='*' element={<ErrorPage />} />
        <Route path='traductor' element={<NewTraductor />} />
        <Route path='dashboard' element={<Dashboard />} />
        <Route path='glossary-management' element={<GlossaryManagement />} />
    </Routes>
  </BrowserRouter>
  )
}



export default App;
